import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { GetWidgetsService } from '../../get-widgets.service';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material/dialog';import { SearchFilters } from '../../../dashboard/search-panel/search-panel.model';

@Component({
  selector: 'app-bucket-performance-on-budget-widget',
  templateUrl: './bucket-performance-on-budget-widget.component.html',
  styleUrls: ['./bucket-performance-on-budget-widget.component.scss']
})
export class BucketPerformanceOnBudgetWidgetComponent implements OnInit {
  dataSource: any;
  width: number = 350;
  height: number = 180;
  type = "scrollmsstackedcolumn2d";
  //type = "stackedbar2d";

 

  
  dataFormat = "json";
  subscriptions: Subscription[] = [];
  isInPopup: boolean = false;
  noData: boolean = false;
  loading: boolean = true;
  // Search Parameters
  @Input() searchParameters: SearchFilters = new SearchFilters();

  constructor(private _widgets: GetWidgetsService,
    private _notification: NotificationsService,
    private _dialog: MatDialog) {
    this.dataSource = {
      chart: {
        // caption: "Budget Performance against Budget",
        // xaxisname: "Bucket",
        // yaxisname: "hrs",

        plottooltext:
          "<b>$seriesName</b> in $label was <b>$dataValue</b>",
        theme: "fusion",
        //labelDisplay: "rotate",
        plotSpacePercent: '30',
        //rotateValues:'1'
      },
      categories: [
        {
          category: []
        }
      ],
      dataset: [
        {
          dataset: [
            {
              seriesname: "Budget Hrs",
              data: [

              ]
            }
          ]
        },
        {
          dataset: [
            {
              seriesname: "Actual Hrs",
              data: [

              ]
            },
            {
              seriesname: "Projected Hrs",
              data: []
            }
          ]
        }
      ]
    };




  }

  ngOnInit() {
    var params: SearchFilters = {
      customer: this.searchParameters.customer,
      jobsite: this.searchParameters.jobsite,
      equipment: this.searchParameters.equipment,
      make: this.searchParameters.make,
      makeUC: this.searchParameters.makeUC,
      model: this.searchParameters.model,
      implement: this.searchParameters.implement,
      ImplementTypes: this.searchParameters.ImplementTypes,
      ComponentTypes: this.searchParameters.ComponentTypes,

      onEq: this.searchParameters.onEq,
      evalA: false,
      evalB: false,
      evalC: false,
      evalX: false,
      NoImps: false,
      family: this.searchParameters.family,
      assetSerial: this.searchParameters.assetSerial,
      GETType: this.searchParameters.GETType,
      PageNumber: 0,
      PageSize: 0
    };

    this._widgets.GetBudgetPerformanceAgainstBudget(params).subscribe(res => {
      console.log("data__", res)
      if (res.JobsiteList != null || res.JobsiteList.length > 0) {
        this.dataSource.categories[0].category = res.JobsiteList;
        this.dataSource.dataset[0].dataset[0].data = res.BudgetHrsList;
        this.dataSource.dataset[1].dataset[0].data = res.ActualHrsList;
        this.dataSource.dataset[1].dataset[1].data = res.ProjectedHrs;
        this.loading = false;
      }else{
        this.loading = true;
        this.noData=true;
      }

     
    })
  }

}
